import React from 'react'

export const Notfound = () =>{
	return(
		<>
			<h1>Notfound Page</h1>
		</>
	)
}